import React, { Component } from "react";
import { Card, Row, Col } from "react-bootstrap";
import RecursiveDataLister from "@unleashit/recursive-data-lister";
import _ from "lodash";


function toFixed(num, fixed) {
  var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
  return num.toString().match(re)[0];
}

let omitByDeep = (obj, shouldOmit, convertBool, convertFloat) => {
  obj = _.clone(obj);
  _.forEach(obj, (value, key) => {
    if (shouldOmit(value, key)) {
      delete obj[key];
    }
    if (convertBool) {
      if (_.isBoolean(value)) {
        obj[key] = value ? "YES" : "NO";
      }
    }
    if (convertFloat) {
      if (Number.isFinite(value)) {
        if (!Number.isInteger(value)) {
          // must be a float?
          obj[key] = toFixed(value, 2);
        }
      }
    }
    if (_.isPlainObject(value)) {
      obj[key] = omitByDeep(value, shouldOmit, convertBool, convertFloat);
    }
  });
  return obj;
};

export default class ObservationDetailCard extends Component {

  render() 
  {
    var displayReceipt = {"receipt": {}, "lines" : {}, "status": {}};
    const displayGridRow = (this.props.currentReceipt)
      ? omitByDeep(
          this.props.currentReceipt,
          (v) => v === null || v === undefined || v === "" || v === 0,
          true,
          true
        ) // immutable. Will NOT change original rowData
      : {"receipt": {}, "lines" : {}, "status": {}};
    if (this.props.currentReceipt) {
      console.log(this.props.currentReceipt);
      // users do not want to see OUI. I'm doing all of this JUST so I can change the label! Stupid.
      const lines = _.clone(displayGridRow.lines);
      const status = _.clone(displayGridRow.status);
      delete displayGridRow.lines;
      delete displayGridRow.status;
      const receipt = displayGridRow;
      displayReceipt = {"receipt": receipt, "lines": lines, "status": status};
    }


    

    return (

      <Card>
        <Card.Header align="center">Receipt Detail</Card.Header>
        <Card.Body>
          <div style={{ width: "100%", height: "100%" }}>
            <Row>
              <Col>
                Receipt
                <RecursiveDataLister
                data={displayReceipt.receipt}
                displayAsList={false} // For array only: show first level children as separate parents. False is default (outputs as a single top level object)
                tag="ul" // parent html tag. ul is default, you can also choose ol or div
                arrayLeafPropName="title" // if set, this will use the property as node labels for arrays of objects (instead of the index). Careful with this, it only works with one property!
                repeatLeafPropName={false} // true is default. If arrayLeafPropName is set, this will remove the prop from the array so it isn't repeated
              />
              </Col>
              <Col>
              Lines
              <RecursiveDataLister
                data={displayReceipt.lines}
                displayAsList={false} // For array only: show first level children as separate parents. False is default (outputs as a single top level object)
                tag="ul" // parent html tag. ul is default, you can also choose ol or div
                arrayLeafPropName="title" // if set, this will use the property as node labels for arrays of objects (instead of the index). Careful with this, it only works with one property!
                repeatLeafPropName={false} // true is default. If arrayLeafPropName is set, this will remove the prop from the array so it isn't repeated
              />
              </Col>
              <Col>
              Status
              <RecursiveDataLister
                data={displayReceipt.status}
                displayAsList={false} // For array only: show first level children as separate parents. False is default (outputs as a single top level object)
                tag="ul" // parent html tag. ul is default, you can also choose ol or div
                arrayLeafPropName="title" // if set, this will use the property as node labels for arrays of objects (instead of the index). Careful with this, it only works with one property!
                repeatLeafPropName={false} // true is default. If arrayLeafPropName is set, this will remove the prop from the array so it isn't repeated
              />
              </Col>

            </Row>
          </div>
        </Card.Body>
      </Card>
    );
  }
}
